const escapeHtml = (value) => String(value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;');

const reportLines = (matches, manuscriptTitle) => {
  const lines = [
    'MANUSCRIPT ANALYSIS REPORT',
    manuscriptTitle || 'Untitled manuscript',
    `Generated: ${new Date().toLocaleString()}`,
    `Possible issues flagged: ${matches.length}`,
    '',
    'These are contextual suggestions, not hard corrections. Review each passage before making changes.',
    '',
  ];

  matches.forEach((match, index) => {
    lines.push(`${index + 1}. ${match.category.toUpperCase()} — ${match.message}`);
    if (match.text) lines.push(`Matched text: “${match.text}”`);
    if (match.suggestion) lines.push(`Possible suggestion: ${match.suggestion}`);
    if (match.excerpt) lines.push(`Context: ${match.excerpt.replace(/\s+/g, ' ').trim()}`);
    lines.push('');
  });

  return lines;
};

export const downloadTextReport = (matches, manuscriptTitle) => {
  const content = reportLines(matches, manuscriptTitle).join('\n');
  const url = URL.createObjectURL(new Blob([content], { type: 'text/plain;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = 'manuscript-analysis.txt';
  link.click();
  URL.revokeObjectURL(url);
};

export const downloadPdfReport = async (matches, manuscriptTitle) => {
  const { jsPDF } = await import('jspdf');
  const pdf = new jsPDF({ unit: 'pt', format: 'letter' });
  const margin = 48;
  const pageHeight = pdf.internal.pageSize.getHeight();
  let y = margin;

  reportLines(matches, manuscriptTitle).forEach((line) => {
    const wrapped = pdf.splitTextToSize(line || ' ', pdf.internal.pageSize.getWidth() - margin * 2);
    wrapped.forEach((part) => {
      if (y > pageHeight - margin) {
        pdf.addPage();
        y = margin;
      }
      pdf.text(part, margin, y);
      y += 17;
    });
  });

  pdf.save('manuscript-analysis.pdf');
};

export const highlightSegments = (content, matches) => {
  const ranges = matches
    .filter(match => match.start >= 0 && match.end > match.start)
    .sort((a, b) => a.start - b.start || a.end - b.end);
  const segments = [];
  let cursor = 0;

  ranges.forEach((match) => {
    if (match.start < cursor) return;
    if (match.start > cursor) segments.push({ text: content.slice(cursor, match.start) });
    segments.push({ text: content.slice(match.start, match.end), match });
    cursor = match.end;
  });

  if (cursor < content.length) segments.push({ text: content.slice(cursor) });
  return segments;
};

export const reportText = (matches, manuscriptTitle) =>
  reportLines(matches, manuscriptTitle).map(escapeHtml).join('\n');